"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Label", {
    enumerable: true,
    get: ()=>Label
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _useLabel = require("./useLabel");
const _renderLabel = require("./renderLabel");
const _useLabelStyles = require("./useLabelStyles");
const _reactSharedContexts = require("@fluentui/react-shared-contexts");
const Label = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useLabel.useLabel_unstable)(props, ref);
    (0, _useLabelStyles.useLabelStyles_unstable)(state);
    const { useLabelStyles_unstable: useCustomStyles  } = (0, _reactSharedContexts.useCustomStyleHooks_unstable)();
    useCustomStyles(state);
    return (0, _renderLabel.renderLabel_unstable)(state);
});
Label.displayName = 'Label'; //# sourceMappingURL=Label.js.map

//# sourceMappingURL=Label.js.map